import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { Percent } from './Percent';
var stripStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
    gap: '12px',
    marginBottom: '20px',
};
var tileStyle = {
    border: '1px solid #e1e7ee',
    borderRadius: '8px',
    padding: '12px 14px',
    background: '#fff',
};
/**
 * AV-03 top summary strip: total records, % valid, error / warning record
 * counts. Renders the headline figures of the latest run (scenario step 5).
 */
export var SummaryStrip = function (_a) {
    var summary = _a.summary;
    var tiles = [
        { labelId: 'ui-czna-authorities.corpusQuality.summary.total', value: React.createElement(FormattedNumber, { value: summary.totalRecords }) },
        {
            labelId: 'ui-czna-authorities.corpusQuality.summary.validPercent',
            value: React.createElement(Percent, { value: summary.validPercent }),
            accent: '#1b7f43',
        },
        {
            labelId: 'ui-czna-authorities.corpusQuality.summary.errors',
            value: React.createElement(FormattedNumber, { value: summary.errorCount }),
            accent: '#a4123f',
        },
        {
            labelId: 'ui-czna-authorities.corpusQuality.summary.warnings',
            value: React.createElement(FormattedNumber, { value: summary.warningCount }),
            accent: '#9a6b00',
        },
    ];
    return (React.createElement("div", { style: stripStyle, "data-test-summary-strip": true }, tiles.map(function (t) {
        var _a;
        return (React.createElement("div", { key: t.labelId, style: tileStyle },
            React.createElement("div", { style: { fontSize: '12px', color: '#5d6b7a', marginBottom: '4px' } },
                React.createElement(FormattedMessage, { id: t.labelId })),
            React.createElement("div", { style: { fontSize: '22px', fontWeight: 700, color: (_a = t.accent) !== null && _a !== void 0 ? _a : '#1f2d3a' } }, t.value)));
    })));
};
